import React from "react"
import { Store } from "./types"
import { StoreItem } from "./StoreItem"
import * as s from "./StoreList.module.scss"


type StoreListProps = {
  items: Store[]
}
export const StoreList = (props: StoreListProps) => {
  return <div className={s.list}>
    {props.items.map((store) => store.url ? <a className={s.link} href={store.url} rel="noopener noreferrer" target="_blank" key={store.id}>
      <StoreItem  store={store} />
    </a> : <div key={store.id} className={s.link}>
        <StoreItem  store={store} />
    </div>)}
  </div>
}
